// import clsx from 'clsx'
// import {FC} from 'react'
// import {WithChildren} from '../react18MigrationHelpers'

// type Props = {
//   className?: string
//   scroll?: boolean
//   height?: number
// }

// const KTCardBody: FC<Props & WithChildren> = ({className, scroll, height, children}) => {
//   return (
//     <div
//       className={clsx(
//         'p-4', // base padding for card body
//         scroll && 'overflow-auto',
//         height && `h-[${height}px]`,
//         className
//       )}
//     >
//       {children}
//     </div>
//   )
// }

// export {KTCardBody}
import {FC} from 'react'
import clsx from 'clsx'
import {WithChildren} from '../react18MigrationHelpers'

type Props = {
  className?: string
  shadow?: boolean
  flush?: boolean
  resetSidePaddings?: boolean
  border?: boolean
  dashed?: boolean
  stretch?: 'stretch' | 'stretch-75' | 'stretch-50' | 'stretch-33' | 'stretch-25'
  rounded?: 'rounded' | 'rounded-top' | 'rounded-bottom'
  utilityP?: number
  utilityPY?: number
  utilityPX?: number
}

const KTCardBody: FC<Props & WithChildren> = ({
  className,
  shadow,
  flush,
  resetSidePaddings,
  border,
  dashed,
  stretch,
  rounded,
  utilityP,
  utilityPY,
  utilityPX,
  children,
}) => {
  const stretchMap: Record<string, string> = {
    stretch: 'w-full',
    'stretch-75': 'w-3/4',
    'stretch-50': 'w-1/2',
    'stretch-33': 'w-1/3',
    'stretch-25': 'w-1/4',
  }

  const roundedMap: Record<string, string> = {
    rounded: 'rounded',
    'rounded-top': 'rounded-t',
    'rounded-bottom': 'rounded-b',
  }

  return (
    <div
      className={clsx(
        'bg-white', // base card background
        border && 'border',
        dashed && 'border-dashed',
        shadow && 'shadow-sm',
        flush ? 'p-0' : 'p-4', // no padding if flush
        resetSidePaddings && 'px-0',
        stretch && stretchMap[stretch],
        rounded && roundedMap[rounded],
        utilityP && `p-${utilityP}`,
        utilityPX && `px-${utilityPX}`,
        utilityPY && `py-${utilityPY}`,
        className
      )}
    >
      {children}
    </div>
  )
}

export {KTCardBody}
